import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsMobile } from '../../../../hooks';
import { TParticiparteResponse } from '../../../../types';

import { StyledText } from '../style';
import { StyledGiftContainer, StyledPrize, StyledWinnerTitle } from './sytle';

type TWinnerCardProps = {
  gameResult: TParticiparteResponse['data'];
  winningText: string | undefined;
};

const WinnerCard = ({ gameResult, winningText }: TWinnerCardProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <Fragment>
      <StyledWinnerTitle $isMobile={isMobile}>{t('youWon')}</StyledWinnerTitle>
      <StyledPrize>{gameResult.prize.name}</StyledPrize>
      <StyledGiftContainer src={gameResult.prize.image} />
      <StyledText
        dangerouslySetInnerHTML={{
          __html: winningText || t('checkYourEmails'),
        }}
      />
    </Fragment>
  );
};

export default WinnerCard;
